import { useState, useEffect } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { useFeatureFlags } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { categoryNameToUrl } from 'utils/format';
import { useShoppingContext } from 'contexts/ShoppingContext';
import BannerService from 'services/banners';
import { type Category } from 'redux/modules/taxonomy/selectors/types';
import { type Banner, type CategoryPath } from 'services/banners/types';

export const useBanners = (level: number, path: string, category: Category) => {
  const { categories: childCategories } = category;
  const [banners, setBanners] = useState<Record<Category['id'], Banner[]>>({});
  const {
    shoppingContext: { customerOrderId },
  } = useShoppingContext();
  const { state: authState } = useAuthentication();
  const { adtechMenuBanners } = useFeatureFlags();

  useEffect(() => {
    if (adtechMenuBanners && level === 2) {
      const fetch = async () => {
        setBanners({
          ...banners,
          [category.id]: await BannerService.getBanners({
            categories: Object.keys(childCategories).map<CategoryPath>(
              cid =>
                [path.slice(1), categoryNameToUrl(childCategories[cid].name)]
                  .join('/')
                  .toLowerCase() as CategoryPath,
            ),
            trolleyId: customerOrderId,
            // file deepcode ignore HardcodedNonCryptoSecret: `Bearer unauthenticated` is not a secret
            authToken: authState.token?.authHeader || 'Bearer unauthenticated',
          }),
        });
      };

      if (!banners[category.id]) {
        fetch();
      }
    }
  }, [adtechMenuBanners, category.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return banners;
};
